import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy,Output, OnInit, ViewEncapsulation, effect, signal} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import * as util from '../../../shared/services/util.service';
import {Make} from '../../../shared/models/brand.model';
import {ActivatedRoute} from '@angular/router';
import {combineLatest, iif, Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {IToyotaLexusModelDetails, ServiceAppointmentState} from '../../../store/service-appointment/service-appointment.reducer';
import * as fromSelectors from '../../../store/service-appointment/service-appointment.selectors';
import {LoadModelYearAndModels, UpdateServiceForm} from '../../../store/service-appointment/service-appointment.actions';
import {SubscriptionList} from '../../../shared/models/asp.types';
import {mergeMap, switchMap, filter, take} from 'rxjs/operators';
import * as fromValidator from '../../service-appointment/service-appointment.validator';
import {VehicleService} from '../../../shared/services/vehicle.service';
import {Department, IVehicle} from '@signal/asp-data-commons';
import {BdcDashboardState} from '../../../store/bdcdashboard/bdcdashboard.reducer';
import * as BdcDashboardActions from '../../../store/bdcdashboard/bdcdashboard.actions';
import {selectUserVehicles, selectUserVehiclesLoading} from '../../../store/bdcdashboard/bdcdashboard.selectors';
import {VehicleCardComponent} from './vehicle-card/vehicle-card.component';
import { selectAppointmentsForVin } from '../../../store/bdcdashboard/bdcdashboard.selectors';
import * as fromDashboard from '../../../store/bdcdashboard/bdcdashboard.selectors';
import {selectCurrentCustomer, selectPendingSearchInput} from '../../../store/search-customers/search-customers.selectors';
import {SearchCustomersState} from '../../../store/search-customers/search-customers.reducer';
import { SettingsState } from 'src/app/modules/store/settings/settings.reducer';
import { selectSettings } from 'src/app/modules/store/settings/settings.selectors';
import { Telematics } from 'src/app/modules/shared/models/telematics.model';
import { DateTime } from 'luxon';
import { FactoryPrintService } from '../../../shared/components/factory-services-dialog/factory-print.service';
import { AspBannerService } from '../../../shared/services/asp-banner.service';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { StateDetails } from 'src/app/modules/shared/models/state';
import { selectStates } from 'src/app/modules/store/dealer/dealer.selectors';
import { DealerState } from 'src/app/modules/store/dealer/dealer.reducer';

@Component({
  selector: 'app-select-vehicle',
  templateUrl: './select-vehicle.component.html',
  styleUrls: ['./select-vehicle.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SelectVehicleComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() stepIndex = 0;
  @Input() showMileageField = true;
  @Output() formEdited:EventEmitter<boolean>=new EventEmitter();
  @Output() toShowFooter=new EventEmitter();
  @Input() src = "";
  vehicles: IVehicle[] = [];
  step: UntypedFormGroup;

  title: string;
  switcherText: string;

  isMakeOther = false;
  isOwnVehicle = true;
  isVinMandate=false;
  makes: Make[] = [];
  models : string[] = [];
  yearmodels: string[] = [];
  preSelectedVin: string;
  telematicsLoading : boolean = false;
  isOwnVehicle$: Observable<boolean>;
  isUserVehiclesLoading$: Observable<boolean>;
  isEditMode$: Observable<boolean>;
  modelYearAndModelsLoading$: Observable<boolean>;
  newvehicle:any;
  milesPlaceholder : string;
  milesIsRequired : string;

  hasExistingAppt = false;
  existingApptText = '';
  isVehicleSelected:boolean=false;
  selectedVehicleDetails : {
    make:string,
    year:string,
    model:string,
  };
  previousMakeModelYear = '';
  dateFormat : string = 'yyyy-MM-dd';

  modelYearSeries: any;
  private subs: SubscriptionList = {};
  private modelYearAndModelsData$: Observable<IToyotaLexusModelDetails>;
  isEditMode: boolean;
  private lastVehicleSelected: string;
  private lastValueVin = '';
  private toyotaLexusModelDetails: IToyotaLexusModelDetails;
  odometerApiError=false;

  filterOptions: any = [];
  filterOptionSelected = 'licensePlate';
  stateOptionSelected;
  statesList;
  filteredStatesList;
  selectedOption = 'service.licensePlate';
  states$: Observable<StateDetails[]>;
  vehicleNotFound = false;
  isSubmitting = false;
  vehicleFound = false;
  srcInternal = signal("");
  isLicenseToVinEnabled = util.getLicenseToVinEnabled();
  isEditAppointmentFlow = false;

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly vehicleService: VehicleService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly cdRef: ChangeDetectorRef,
    private readonly bdcDashboardState: Store<BdcDashboardState>,
    private readonly bannerService: AspBannerService,
    private readonly serviceAppointmentState: Store<ServiceAppointmentState>,
    private readonly searchCustomersState: Store<SearchCustomersState>,
    private settingsState: Store<SettingsState>,
    private factoryPrintService: FactoryPrintService,
    private readonly translate: TranslateService,
    private readonly dealerState: Store<DealerState>
  ) {
    this.makes = util.getMakes();
    this.bindThis();
    this.translate.get('COUNTRYTRANSLATION.enterMile').subscribe(enterMileKey => {
      this.milesPlaceholder = this.translate.instant(`service.${enterMileKey}`);
    });
    this.translate.get('COUNTRYTRANSLATION.milesIsRequired').subscribe(milesRequiredKey => {
      this.milesIsRequired = this.translate.instant(`service.${milesRequiredKey}`);
    });
    this.subs.query = this.activatedRoute.queryParams.subscribe(params => {
      this.isEditAppointmentFlow = !!params.id;
      this.isVehicleSelected = params.selectedVehicle ? true :false;
      if(params.selectedVehicle && !params.vin){
        this.selectedVehicleDetails = {
          year : params.year,
          make : params.make,
          model : params.model
        }
      }else{
        this.preSelectedVin = params.vin;
      }
    });
    effect(()=> {
      this.srcInternal.set(this.src);
    }, { allowSignalWrites: true });
  }

  ngOnInit(): void {
    this.subs.apptFordashboard = this.bdcDashboardState.select(fromDashboard.selectServiceApptForDashboard).subscribe((response)=>{
      const temp = []
      const uniqueResponse = response.map(obj => {
        if(!temp.includes(obj.vin)){
          temp.push(obj.vin)
          return obj
        }
      }).filter(f => f)
      this.newvehicle = uniqueResponse.filter((item)=>{
        return item.isOwnVehicle;
      });
     });

    this.dealerState.select(selectStates).pipe(
      filter((states): states is StateDetails[] => Array.isArray(states) && states.length > 0),
      take(1)
    )
    .subscribe(states => {
      this.statesList = states;
      this.filteredStatesList = [...states];
    });

    if (this.isLicenseToVinEnabled && !this.filterOptions.some(opt => opt.filterId === 'licensePlate')) {
      this.filterOptions = [
        { filterId: 'licensePlate', filterName: 'License Plate' },
        { filterId: 'vin', filterName: 'VIN' }
      ];
      this.filterOptionSelected = 'licensePlate';
      this.selectedOption = 'service.licensePlate';
    } else {
      this.filterOptions = [{ filterId: 'vin', filterName: 'VIN' }];
      this.filterOptionSelected = 'vin';
      this.selectedOption = 'service.vin';
    }
    this.ready();
    this.subs.isNTL = this.serviceAppointmentState.select(fromSelectors.selectVehicleMake).subscribe(t => {
          this.isMakeOther = t?.toUpperCase() === 'OTHER';
    });
  }

  onVehicleFieldChange(
    change: { field: string; value: string },
    vehicle: IVehicle
  ) {
   
    /* for now only mileage is changing, hence no checking for field & value */
    setTimeout(() => {
      if (this.step.controls.vin.value !== vehicle.vin) {
        this.serviceAppointmentState.dispatch(new UpdateServiceForm({
          path: 'vehicleForm',
          value: {...vehicle, mileage: +(change?.value || 0), isOwnVehicle: true}
        }));
      } else {
        this.setFormControlValue('mileage', +(change?.value || 0));
      }
    });
  }

  /**
   * Sets the necessary fields and form validators based on vehicle type 'Own' or 'Different'
   */
  toggleVehicleType() {
    if(this.srcInternal() !== "signal") {
      this.resetAllInputs();
      if (this.isOwnVehicle) {
        this.setOwnVehicleFalse();
      } else {
        this.setOwnVehicleTrue();
      }
    }
  }

  /**
   * Sets the subscriptions of the current step form
   *
   * 1. Make formControl - to check whether 'Other' is chosen or not
   */
  setFormSubscription() {
    this.subs.stepValueChanges = this.step.valueChanges.subscribe(()=>{
      this.formEdited.emit(!this.step.dirty);
    });
    this.subs.makeSub = this.step.get('make').valueChanges.subscribe((make: string) => {
      if (this.step.get('isOwnVehicle')?.value) {
        return;
      }
      if (this.isOtherMake(make)) {
        this.isMakeOther = true;
        this.step.controls.year.reset(null, {emitEvent: false});
        this.step.controls.model.reset(null, {emitEvent: false});
      } else {
        this.isMakeOther = false;
        if (make === 'Toyota') {
          this.modelYearSeries = this.toyotaLexusModelDetails.toyota;
        } else if (make === 'Lexus') {
          this.modelYearSeries = this.toyotaLexusModelDetails.lexus;
        }
        this.step.controls.year.reset('', {emitEvent: false});
        this.step.controls.model.reset('', {emitEvent: false});
        if(this.modelYearSeries){
          const yearArray = Object.keys(this.modelYearSeries).sort((a, b) => b.localeCompare(a));
          this.yearmodels = yearArray;

        }else{
          this.yearmodels = [];
        }
      }
      if(this.srcInternal() === "signal") {
        return;
      }
      this.step.controls.model.reset('', {emitEvent: false});
      this.step.controls.imageUrl.reset('', {emitEvent: false});
      this.models=[];
      this.resetGroupTwoFields(make);
    });

    this.subs.yearSub = this.step.get('year').valueChanges.subscribe((data: string) => {
      if(this.srcInternal() === "signal") {
        return;
      }
      if (this.step.get('isOwnVehicle')?.value) {
        return;
      }
      if (!this.isMakeOther) {
        const chosenYear = this.step.controls.year.value;
        if (this.modelYearSeries && chosenYear) {
          const dataOfModel = this.modelYearSeries[chosenYear];
          const sortedModelKeys = Object.keys(dataOfModel).sort((a,b)=> a.localeCompare(b));
          this.models = sortedModelKeys;
        }
      }
      this.step.controls.model.reset('', {emitEvent: false});
      this.step.controls.imageUrl.reset('', {emitEvent: false});
      this.resetGroupTwoFields(data);
    });
    this.subs.modelSub = this.step.get('model').valueChanges.subscribe((data: string) => {
      if(this.srcInternal() === "signal") {
        return;
      }
      if (this.step.get('isOwnVehicle')?.value) {
        return;
      }
      this.resetGroupTwoFields(data);
    });

    this.subs.vinSub = this.step.get('vin').valueChanges.subscribe((data: string) => {
      const isOwnVehicle = this.step.get('isOwnVehicle')?.value;
      const mileageControl = this.step.get('mileage');
      this.odometerApiError = false;
      mileageControl.markAsUntouched();
    
      if (isOwnVehicle) {
        return;
      }
    
      this.resetGroupOneFields(data);
    
      if (data && data.length === 17 && this.filterOptionSelected === 'vin' && !this.isMakeOther) {
        this.getVehicleColorForLexus(data)
      }
    });

    this.subs.licensePlateSub = this.step.get('licensePlate').valueChanges.subscribe((data: string) => {
      const mileageControl = this.step.get('mileage');
      this.odometerApiError = false;
      mileageControl.markAsUntouched();
      this.step.controls.state.patchValue('', {emitEvent: false});
      this.resetInfoText();
      if(!data || data.length<2){
        this.step.controls.state.disable();
      }else if(data.length>1) {
        this.step.controls.state.enable();
      }
    })

    
    this.subs.mileage = this.step.get('mileage').valueChanges.subscribe((data: string) => {
      if(data) {
        this.odometerApiError = false;
      }
    });
    
    this.subs.vehicleImageSub = this.step.valueChanges.subscribe(value => {
      // const rawValue = this.step.getRawValue();
      /* When the vehicle info is partial, no need to set image */
      if (this.srcInternal() === 'signal') {
        return
      };

      if (!this.missingCoreFields(value)) {
        if (!this.isEditMode && !value.vin) {
          this.hideVehicle()
        };
        return;
      }


      const chosenVehicle = `${value.make}#${value.year}#${value.model}`;
      if (this.lastVehicleSelected === chosenVehicle) {
        return;
      }

      this.lastVehicleSelected = chosenVehicle;
        /* Other makes don't have images in EFC */
        if (this.isOtherMake(value.make)) {
          this.step.controls.imageUrl.setValue(util.GLOBAL_CONSTANT.placeholderCarImage);
          return;
        }
      if(this.previousMakeModelYear !== `${value.make}${value.model}${value.year}`){
        this.previousMakeModelYear = `${value.make}${value.model}${value.year}`;
        this.hideVehicle();
      }
      if(util.countryCd.includes('US')) {
        if(!value.isOwnVehicle){
          const modelData = this.modelYearSeries?.[value.year]?.[value.model];
          const relativeURL = modelData?.['carJellyImageUrl'];
          this.step.controls.imageUrl.setValue(relativeURL);
          this.bannerService.show();
          if(relativeURL) {
            this.showVehicle(relativeURL);
          }
        } else {
          this.showVehicle(value.imageUrl);
        }
      } 
      /* // this is else logic dealing with vehicle images for other than us country  
      else {
        const brand = value.make.toUpperCase().substr(0, 3);
        let model;
        if (value.make.toLowerCase() === 'toyota') {
          model = value.model.toLowerCase().replace(' ', '');
          if(!value.isOwnVehicle){
            this.subs.color = this.vehicleService.getVehicleColors(brand, value.year, model, '').subscribe((data: VehicleImage) => {
              const exteriorColors = data.colors?.exterior;
              const exteriorColor = exteriorColors[0];
              const relativeURL = brand?.toLowerCase() === 'lex'?
              exteriorColor?.applicable[0]?.override?.images?.on_swatch_image :
              exteriorColor?.applicable[0]?.override?.images?.car_jelly_image ;
    
              // Updating the image url in the form
              this.step.controls.imageUrl.setValue(relativeURL);
              this.bannerService.show();
              this.showVehicle(relativeURL);
            },err=>{
              this.step.controls.imageUrl.setValue(undefined);
              this.factoryPrintService.setUrl(undefined);
              this.bannerService.show();
              this.hideVehicle();
            });
          }else{
            this.showVehicle(value.imageUrl);
          }
        } else if (value.make.toLowerCase() === 'lexus') {
          model = value.model.toLowerCase().replace(/[0-9]/g, '').replace(' ', '');
          if(!value.isOwnVehicle){
            this.subs.vehicleData = this.vehicleService.getVehicleColorForLexus(value, false).subscribe(data=>{
            if(data  && data.status?.code === 201 && data.data && data.data.model && data.data.model.length> 0){
              this.bannerService.show();
              this.step.controls.imageUrl.setValue(data.data.model[0]);
              this.showVehicle(data.data.model[0]);
            }else{
              this.step.controls.imageUrl.setValue(undefined);
              this.hideVehicle();
            }
          },err=>{
            this.step.controls.imageUrl.setValue(undefined);
            this.bannerService.show();
            this.hideVehicle();
            })
          }else{
            this.showVehicle(value.imageUrl);
          }
        }else{
          this.hideVehicle();
        }
      } */
    });
  }

  missingCoreFields(value) {
    return value.make && value.year && value.model
  }

  resetGroupOneFields(value: string) {
    if (!value){
      this.lastValueVin = '';
      return;
    }

    if (value === this.lastValueVin) {
      return;
    }

    this.lastValueVin = value;
    this.hasExistingAppt = false;
  
    if (value.length === 17) {
      this.handleVinLength(value);
    }
    if(this.srcInternal() !== "signal") {
      this.resetFormControls();
    }
  }
  
  handleVinLength(value: string) {
    const queryText = value;
    this.bdcDashboardState.dispatch(new BdcDashboardActions.LoadAppointmentsForVin({ queryText }));
  
    this.subs.apptForVin = this.bdcDashboardState.select(selectAppointmentsForVin).subscribe(response => {
      if (response && response.length > 0 && response[0]) {
        this.processAppointments(response);
      } else {
        this.hasExistingAppt = false;
        this.step.controls.isInputVinBased.setValue(true);
      }
    });
  
    this.fetchMilageFromTelematics(value);
  }
  
  processAppointments(response: any[]) {
    const dateArray = [];
    let count = 0;
    const today = DateTime.now().toFormat(this.dateFormat);
    const currentdate = DateTime.fromFormat(today, this.dateFormat);
  
    response.forEach(appointment => {
      const minDate = DateTime.fromFormat(appointment.appointmentStartDate, this.dateFormat);
      if (minDate >= currentdate && count <= 9) {
        const displayDate = minDate.toFormat('MMM dd');
        dateArray.push(displayDate);
        this.hasExistingAppt = true;
        count++;
      }
    });
  
    const sortedDatesArray = this.sortDateArray(dateArray);
    const lastElement = count > 1 && sortedDatesArray.length > 0 ? 'and ' + sortedDatesArray.splice(count - 1, 1) : '';
    this.existingApptText = `${this.translate.instant('service.vehicleHasUpcomingAppointmentsScheduledOn')} ${dateArray.join()} ${lastElement}`;
  }
  
  resetFormControls() {
    this.step.controls.imageUrl.setValue(util.GLOBAL_CONSTANT.placeholderCarImage);
    this.step.controls.make.reset('', { emitEvent: false });
    this.step.controls.year.reset('', { emitEvent: false });
    this.step.controls.model.reset('', { emitEvent: false });
    this.step.controls.otherMake.reset('', { emitEvent: false });
  }
  

  fetchMilageFromTelematics(vin: string) {
    if (this.telematicsLoading || this.isMakeOther){
      return ;
    }
  
    const mileageMessage = this.translate.instant('service.fetchingDataFromTelematics');
    if (this.isEditMode) {
      this.updateServiceFormMileage(mileageMessage);
      this.setTelematics(vin, this.vehicles[0].mileage);
    } else {
      // Show fetching message in placeholder
      this.milesPlaceholder = mileageMessage;
      this.setTelematics(vin, null);
    }
  }
  
  updateServiceFormMileage(mileage: string) {
    this.serviceAppointmentState.dispatch(new UpdateServiceForm({
      path: 'vehicleForm',
      value: { ...this.vehicles[0], mileage }
    }));
  }
  

  setTelematics(vin, previousMileage) {
    this.telematicsLoading = true;
    const milesPlaceholderTxt = this.translate.instant(`service.${this.translate.instant('COUNTRYTRANSLATION.enterMile')}`);
  
    this.subs.telematics = this.vehicleService.getTelematics(vin,Department.SERVICE).subscribe(
      data => this.handleTelematicsSuccess(data, milesPlaceholderTxt, previousMileage),
      _err => this.handleTelematicsError(milesPlaceholderTxt, previousMileage)
    );
  }
  
 handleTelematicsSuccess(data, milesPlaceholderTxt, previousMileage) {
  if (data.status.code === 200) {
      this.milesPlaceholder = milesPlaceholderTxt;
      const telematicsData = Telematics.getTelematics(data?.data);
      const mileage = telematicsData?.mileage || previousMileage;
      const ppmEligible = telematicsData?.protectionProduct?.protectionProductAvailableScore > 0;
      const protectionProducts = telematicsData?.protectionProduct?.protectionProducts;

      if (this.isEditMode) {
        this.serviceAppointmentState.dispatch(new UpdateServiceForm({
          path: 'vehicleForm',
          value: { ...this.vehicles[0], mileage, protectionProducts, ppmEligible }
        }));
      } else {
        this.step.controls['protectionProducts'].setValue(protectionProducts);
        this.step.controls['ppmEligible'].setValue(ppmEligible);
        this.step.controls['mileage'].setValue(mileage);
      }
      
      if(!mileage) {
        this.odometerApiError = true;
        this.step.controls['mileage'].markAsTouched();
      } else {
        this.odometerApiError = false;
      }
    }
    this.step.controls['mileage'].enable();
    this.telematicsLoading = false;
  }
  
 handleTelematicsError(milesPlaceholderTxt, previousMileage) {
    this.milesPlaceholder = milesPlaceholderTxt;

    if (this.isEditMode) {
      this.serviceAppointmentState.dispatch(new UpdateServiceForm({
        path: 'vehicleForm',
        value: { ...this.vehicles[0], mileage: previousMileage }
      }));
    } else {
      this.step.controls['mileage'].setValue(previousMileage);
    }

    this.step.controls['mileage'].enable();
    this.telematicsLoading = false;

   this.odometerApiError = true;
   this.step.controls['mileage'].markAsTouched();
  }

  resetGroupTwoFields(value: string) {
    if (!!value && this.srcInternal() !== "signal") {
      this.step.controls.isInputVinBased.setValue(false);
      this.hasExistingAppt = false;
      this.step.controls.vin.reset('', {emitEvent: false});
      this.odometerApiError = false;
    }
  }

  /**
   * Triggers the value change event of the given formGroup, by re-setting one of the form control value
   *
   */
  triggerValueChangeEvent(step: UntypedFormGroup) {
    this.setFormControlValue('isOwnVehicle', step?.controls.isOwnVehicle.value);
  }

  /**
   * Sets the form control value to the given form control name in the formGroup
   */
  setFormControlValue(formControlName: string, formControlValue: any) {
    this.step.controls[formControlName].markAsDirty();
    this.step.controls[formControlName].setValue(formControlValue);
  }

  /**
   * Validates the VIN input having error for 17 digit validation
   *
   * @returns true if control is valid
   */
  isNot17Digit(): boolean {
    return (
      this.step.controls.vin.errors?.pattern &&
      this.step.controls.vin.errors?.pattern?.requiredPattern === '^[.]{17}$'
    );
  }

  /**
   * Validates the VIN input having error for alpha numeric validation
   */
  isNotCharAndDigit(): boolean {
    return (
      this.step.controls.vin.errors?.pattern &&
      this.step.controls.vin.errors?.pattern?.requiredPattern === '^[\\w\\d]*$'
    );
  }

  onKeyPress($event) {
  }

  ready() {
    this.prepareForm();
    this.setUpStore();
    // this.gsap.animateOwnVehicleCards(); //TODO - Restore the animation
  }

  ngOnDestroy(): void {
    util.unsubscribeSubscriptions(this.subs);
  }

  ngAfterViewInit(): void {
    // this.setInitialVehicleSelection();
  }

  vehicleSelected(vehicle: IVehicle, vehicleCardComponent: VehicleCardComponent) {
    this.step.patchValue({...vehicle});
    vehicleCardComponent.triggerOnMileageChange();
  }

  private resetAllInputs() {
    ['mileage', 'description', 'imageUrl'].forEach(fc => this.step.controls[fc].reset('', {emitEvent: false}));
    this.resetGroupOneFields('value');
    this.resetGroupTwoFields('value');
    this.odometerApiError = false;
  }

  /**
   * Prepares the form group for vehicle selection with necessary form controls with default value
   */
  private prepareForm() {
    this.step = this.formBuilder.group({
        isOwnVehicle: [true],
        isInputVinBased: [false],
        description: [''],
        imageUrl: [''],
        vin: [''],
        licensePlate: [''],
        state: [''],
        make: [''],
        otherMake: [''],
        year: [''],
        model: [''],
        mileage: [0],
        protectionProducts: [],
        ppmEligible: [false]
      }
    );
    this.step.setValidators(fromValidator.chooseVehicleValidator());
    this.setFormSubscription();
  }

  private bindThis() {
    this.isNotCharAndDigit = this.isNotCharAndDigit.bind(this);
    this.isNot17Digit = this.isNot17Digit.bind(this);
  }

  private setOwnVehicleTrue() {
    this.isOwnVehicle = true;
    this.translate.get('service.chooseFromCustomerVehicles').subscribe(trans => {
      this.title = trans;
    });
    this.translate.get('service.chooseAnotherVehicle').subscribe(trans => {
      this.switcherText = trans;
    });
    this.step.controls.isOwnVehicle.setValue(this.isOwnVehicle);
    // this.gsap.animateOwnVehicleContainer();
  }

  private setOwnVehicleFalse() {
    this.isOwnVehicle = false;
    this.translate.get('service.enterCustomerVehicleDetails').subscribe(trans => {
      this.title = trans;
    });
    this.translate.get('service.chooseFromCustomerVehicles').subscribe(trans => {
      this.switcherText = trans;
    });
    this.step.controls.isOwnVehicle.setValue(this.isOwnVehicle);
    // this.gsap.enterDifferentVehicleContainer();
  }

  private isOtherMake(make: string) {
    return make?.toLowerCase() === 'other';
  }

  private setInitialVehicleSelection() {
    if (this.preSelectedVin && this.vehicles?.length) {
      const vehicle = this.vehicles.find(v => v.vin === this.preSelectedVin);
      if(vehicle === undefined && this.isVehicleSelected){
        this.serviceAppointmentState.dispatch(new UpdateServiceForm({path: 'vehicleForm', value: {vin : this.preSelectedVin, isOwnVehicle: false}}));
        return;
      }
      if(this.isVehicleSelected){
        this.vehicles = this.vehicles.filter(vehicle=>{
         if( vehicle.vin===this.preSelectedVin) {
          return vehicle;
         }
        });
      }
      if (this.step.controls.vin.value !== vehicle.vin) {
        this.setTelematics(vehicle.vin,vehicle.mileage);
        this.serviceAppointmentState.dispatch(new UpdateServiceForm({path: 'vehicleForm', value: {...vehicle, ppmEligible: this.step.get('ppmEligible').value, protectionProducts: this.step.get('protectionProducts').value,  isOwnVehicle: true}}));
      }
    }else if(this.selectedVehicleDetails && this.isVehicleSelected){
      this.serviceAppointmentState.dispatch(new UpdateServiceForm({path: 'vehicleForm', value: { make : this.selectedVehicleDetails.make , model : this.selectedVehicleDetails.model , year : this.selectedVehicleDetails.year , isOwnVehicle: false}}));
    }
  }

  private setUpStore() {
    this.serviceAppointmentState.dispatch(new LoadModelYearAndModels());

    /* Observables */
    this.isUserVehiclesLoading$ = this.bdcDashboardState.select(selectUserVehiclesLoading);
    this.isEditMode$ = this.serviceAppointmentState.select(fromSelectors.selectIsEditMode);
    this.isOwnVehicle$ = this.serviceAppointmentState.select(fromSelectors.selectVehicleFormIsOwnVehicle);
    this.modelYearAndModelsData$ = this.serviceAppointmentState.select(fromSelectors.selectModelYearAndModelsData);
    this.modelYearAndModelsLoading$ = this.serviceAppointmentState.select(fromSelectors.selectModelYearAndModelsLoading);

    /* Explicit subscriptions to the store slices */
    this.subs.isOwnVehicleSub = this.isOwnVehicle$.subscribe(o => {
      o ? this.setOwnVehicleTrue() : this.setOwnVehicleFalse();

    });
    this.subs.settings = this.settingsState.select(selectSettings).subscribe(settings => {
      this.isVinMandate = settings?.portal?.mandateVin;
      if (this.isVinMandate) {
        this.step.controls.vin.setValidators(this.vinValidator());
      }
    });

      this.subs.editAndCustomer = combineLatest([
        this.isEditMode$.pipe(switchMap((isEditMode: boolean) => {
          this.isEditMode = isEditMode;
          return this.searchCustomersState.select(selectCurrentCustomer);
        })),
        this.serviceAppointmentState.select(fromSelectors.selectAppointmentForm),
        this.searchCustomersState.select(selectPendingSearchInput)
      ]).subscribe(([customer, appointmentForm, pendingSearchInput]) => {
        if (this.isEditMode || this.isEditAppointmentFlow) {
          return;
        }
        if (!customer) {
          const isPendingVinFlow = pendingSearchInput?.filterType === 'vin';
          const pendingVin = (pendingSearchInput?.query || '').trim();

          const vehicleForm = appointmentForm?.vehicleForm;
          const isVehicleFormEmpty = !vehicleForm?.vin && !vehicleForm?.licensePlate && !vehicleForm?.make && !vehicleForm?.year && !vehicleForm?.model;

          if (isPendingVinFlow && isVehicleFormEmpty) {
            const shouldPatchVinPrefill = appointmentForm?.vehicleForm?.vin !== pendingVin
              || appointmentForm?.vehicleForm?.isInputVinBased !== true
              || appointmentForm?.vehicleForm?.isOwnVehicle !== false;

            if (shouldPatchVinPrefill) {
              this.vehicleService.clearCurrentCustomerTelematics();
              this.filterOptionSelected = 'vin';
              this.step.patchValue(
                { vin: pendingVin, licensePlate: '', state: '', isInputVinBased: true, isOwnVehicle: false },
                { emitEvent: false }
              );
              this.serviceAppointmentState.dispatch(new UpdateServiceForm({
                path: 'vehicleForm',
                value: { ...this.step.value, vin: pendingVin, licensePlate: '', state: '', isInputVinBased: true, mileage: '', isOwnVehicle: false }
              }));
            }
          }
          else if (!appointmentForm?.vehicleForm?.vin && isVehicleFormEmpty) {
            const shouldPatchVehicleForm = appointmentForm?.vehicleForm?.isOwnVehicle !== false
              || appointmentForm?.vehicleForm?.isInputVinBased !== false;
            if (shouldPatchVehicleForm) {
              this.serviceAppointmentState.dispatch(new UpdateServiceForm({
                path: 'vehicleForm',
                value: { ...this.step.value, mileage: appointmentForm?.vehicleForm?.mileage ?? '', isOwnVehicle: false, isInputVinBased: false }
              }));
            }
          }
        }

      });
    /* For the guest user the default value for 'isOwnVehicle' is false */
    /*if (!this.signedIn) {
      const vehicle = {...this.step.value, isOwnVehicle: false};
      this.serviceAppointmentState.dispatch(new UpdateServiceForm({path: 'vehicleForm', value: vehicle}));
    }*/

    this.subs.displayVehiclesSub =
      this.isEditMode$.pipe(
        switchMap((isEditMode: boolean) =>
          iif(() => {
              this.isEditMode = isEditMode;
              return isEditMode;
            },
            this.serviceAppointmentState.select(fromSelectors.selectAppointmentVehicleAsArray),
            this.bdcDashboardState.select(selectUserVehicles)
          ))).subscribe(vehicles => {
        this.vehicles = vehicles;
        if (this.isEditMode) {
          this.prepareFormForEdit(vehicles);
        } else {
          this.setInitialVehicleSelection();
        }
      });

    this.subs.modelYearAndModelsDataSub = this.isEditMode$.pipe(
      mergeMap((isEditMode: boolean) =>
        iif(() => !isEditMode, this.modelYearAndModelsData$)
      )
    ).subscribe(data => {
      this.toyotaLexusModelDetails = data;
    });
  }

  private prepareFormForEdit(vehicles) {
    this.bannerService.update(vehicles[0].imageUrl);
    this.bannerService.showCarImage();
    this.unsubCreateModeSubscription();

    /* Disable the formControls (fc) which are not editable */
    ['make', 'otherMake', 'year', 'model', 'vin']
      .forEach(fc => this.step.controls[fc]
        .disable({emitEvent: false}));
    if(vehicles[0].vin){
      this.fetchMilageFromTelematics(vehicles[0].vin)
    }
    this.yearmodels = vehicles.map(v => v.year);
    this.models = vehicles.map(v => v.model);
    this.isMakeOther=(vehicles[0].make.toString().toLowerCase()==='other' && 
    vehicles[0].isOwnVehicle===false) ? true : false;
  }

  private unsubCreateModeSubscription() {
    ['vinSub', 'modelSub', 'yearSub', 'makeSub']
      .forEach( sub => this.subs[sub]?.unsubscribe());
  }
  toShowFooterDetails(event){
    this.toShowFooter.emit(event);
  }
  vinValidator(): ValidatorFn {
    return (control: UntypedFormControl): ValidationErrors => {
      if (!this.step.controls.vin.value) {
        return { required: this.translate.instant('service.vinIsRequired') };
      } else {
        return null;
      }
    };
  }
  private sortDateArray(dateArray:string[]):string[]{
    const sortedDatesArray = dateArray.sort((a, b) => {
      return <any>new Date(b) - <any>new Date(a);
    });
    return sortedDatesArray.reverse()
  }
  showVehicle(relativeURL){
    this.bannerService.showCarImage();
    this.bannerService.update(relativeURL);
    this.factoryPrintService.setUrl(relativeURL);
  }
  hideVehicle(){
    this.bannerService.hideCarImage();
    this.bannerService.update(undefined);
    this.factoryPrintService.base64CarImg = undefined;
  }
  isVehicleAtOwnedVehicles(){
    return _.every(this.newvehicle.map(vehicle => this.vehicles[0]?.vin !== vehicle?.vin));
  }

  hasError(controlName: string, errorName: string){
    return this.step.get(controlName).hasError(errorName);
  }

  filter(value): void {
    const filterValue = value.toLowerCase();
    this.filteredStatesList = this.statesList.filter(o => o.name.toLowerCase().includes(filterValue));
  }

  displayStateName = (abbrev: string) => {
    if (!abbrev) {
      return '';
    }
    const state = this.statesList.find(s => s.abbreviation === abbrev);
    return state ? state.name : '';
  };

  onSelectingFilterOption(value){
    this.resetInfoText();
    this.filterOptionSelected = value;
    this.step.patchValue({ licensePlate : '' });
    this.step.patchValue({ vin : '', emitEvent: false});
    this.step.controls.licensePlate.setValidators([Validators.required]);
    this.step.controls.licensePlate.markAsUntouched();
    this.step.controls.licensePlate.setErrors(null);
    this.selectedOption = 'service.'+value;
    if(value === 'licensePlate'){
      this.step.controls.state.setValidators([Validators.required]);
      this.step.updateValueAndValidity();
    }else {
      this.step.controls.state.patchValue('');
      this.step.controls.state.setValidators([]);
      this.step.controls.state.setErrors(null);
      this.step.updateValueAndValidity();
    }
  }

  getVehicleColorForLexus(data){
    this.subs.vehicleDetails = this.vehicleService.getVehicleColorForLexus({ vin: data }, false).subscribe(
      response => {
        if (response && response.status?.code === 201 && response.data && response.data.length > 0) {
          if(response.data[0].description){
            this.step.controls.description.patchValue(response.data[0].description);
          }
          if (this.srcInternal() === "signal") {
            const vehicle = {
              make: response.data[0].make,
              model: response.data[0].model,
              year: String(response.data[0].year),
              imageUrl: response.data[0].imageUrl
            }
            this.step.patchValue(vehicle);
            this.showVehicle(vehicle.imageUrl);
          } else {
            this.bannerService.show();
            const imageUrl = response.data[0].imageUrl;
            this.step.controls.imageUrl.setValue(imageUrl);
            this.showVehicle(imageUrl);
          }
        }
      },
      _error => {
        this.step.controls.imageUrl.setValue(undefined);
        this.bannerService.show();
        this.hideVehicle();
      }
    );
  }

  onOptionSelected(){
    const licensePlate = this.step.get('licensePlate').value;
    const state = this.step.get('state').value
    this.searchByLicensePlate(licensePlate, state);
  }

  searchByLicensePlate(licensePlate, state){
    this.isSubmitting = true;
    this.resetInfoText();
    this.step.controls.vin.patchValue('')
    this.subs.vehicleDetails = this.vehicleService.searchByLicensePlate(licensePlate, state).subscribe(
      response => {
        this.isSubmitting = false;
        if (response?.data?.[0]?.vin)  {
          this.step.controls.vin.patchValue(response?.data[0]?.vin)
          this.vehicleFound = true;
        }else {
          this.vehicleNotFound = true;
        }
        if(response?.data[0].description){
          this.step.controls.description.patchValue(response?.data[0].description);
        }
      },
      _error => {
        this.isSubmitting = false;
        this.vehicleNotFound = true;
      }
    );
  }

  resetInfoText(){
    this.vehicleNotFound = false;
    this.vehicleFound = false;
    this.hasExistingAppt = false;
  }
}
